import { AlertDialog } from '@base-ui/react/alert-dialog';
import { Button } from '@/components/ui/Button';
import { Separator } from '@/components/ui/Separator';
import { useSettingsDiscard } from '@/providers/settings/SettingsContext';

export const SettingsDiscardDialog = () => {
  const { discardOpen, handleCancelDiscard, handleConfirmDiscard } =
    useSettingsDiscard();

  return (
    <AlertDialog.Root
      onOpenChange={(open) => {
        if (!open) handleCancelDiscard();
      }}
      open={discardOpen}
    >
      <AlertDialog.Portal>
        <AlertDialog.Backdrop className="fixed inset-0 z-60 bg-black/40 transition-opacity duration-180 data-ending-style:opacity-0 data-starting-style:opacity-0" />
        <AlertDialog.Popup className="fixed top-1/2 left-1/2 z-60 w-80 -translate-1/2 rounded-md border border-border bg-surface shadow-lg">
          <div className="px-5 pt-5 pb-3">
            <AlertDialog.Title className="text-sm lg:text-base font-semibold text-foreground">
              Discard unsaved changes?
            </AlertDialog.Title>
            <AlertDialog.Description className="mt-1 text-sm/relaxed lg:text-base/relaxed text-foreground-muted">
              Your edits to settings will be lost.
            </AlertDialog.Description>
          </div>
          <Separator />
          <div className="flex items-center justify-end gap-4 p-3">
            <AlertDialog.Close
              render={
                <Button onClick={handleCancelDiscard} size="sm" variant="ghost">
                  Cancel
                </Button>
              }
            />
            <Button onClick={handleConfirmDiscard} size="sm" variant="danger">
              Discard
            </Button>
          </div>
        </AlertDialog.Popup>
      </AlertDialog.Portal>
    </AlertDialog.Root>
  );
};
